import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/chigua/Navbar";
import Footer from "@/components/chigua/Footer";

export default function SiteLayout() {
  const [showTop, setShowTop] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 640);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-background-50 text-foreground-900">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-30 grid h-11 w-11 place-items-center rounded-full bg-primary-500 text-lg text-background-50 shadow-lg transition hover:bg-primary-600"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}